import styled from "styled-components";
import { type ColorProps, type MaxWidthProps, color, maxWidth } from "styled-system";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Background from "../../../../../../../common-deprecated/styles/v2/lexus/components/Background";
import * as TextStyles from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as FormStyles from "../../../../../../../common-deprecated/styles/v2/lexus/components/Form";

export const Visual = styled.div`
    display: flex;
    justify-content: center;
    max-width: 100%;
    padding: ${theme.space[3]}px;
    @media ${getBreakpoint("up", "md")} {
        padding: ${theme.space[4]}px;
    }
    svg {
        max-width: 100%;
        height: auto;
    }
`;

export const Header = styled.div`
    padding: ${theme.space[5]}px ${theme.space[3]}px;
    @media ${getBreakpoint("up", "lg")} {
        padding: ${theme.space[5]}px;
    }
`;

export const Content = styled(Background.Mist)`
    padding: ${theme.space[5]}px ${theme.space[3]}px;
    @media ${getBreakpoint("up", "lg")} {
        padding: 50px ${theme.space[5]}px;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.space[3]}px 0;
    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;
        padding: ${theme.space[4]}px 0;
    }
    @media ${getBreakpoint("up", "lg")} {
        padding: ${theme.space[5]}px 0;
    }

    ${Button.ButtonTertiary} {
        width: auto !important; /* Fix for issue with wrong alignment on mobile */
    }

    ${Button.ButtonTertiary} + ${Button.ButtonPrimary} {
        margin-top: ${theme.space[3]}px;
        @media ${getBreakpoint("up", "md")} {
            margin-top: 0;
            margin-left: ${theme.space[4]}px;
        }
    }

    html[dir="rtl"] & {
        ${Button.ButtonTertiary} + ${Button.ButtonPrimary} {
            @media ${getBreakpoint("up", "md")} {
                margin-left: auto;
                margin-right: ${theme.space[4]}px;
            }
        }
    }
`;

export const Legend = styled.ul`
    display: block;
    margin: 0 0 ${theme.space[3]}px;
    padding: 0 0 ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.platinumLight};
`;

export const Text = styled(TextStyles.Body)`
    color: ${theme.colors.platinumDark};
`;

export const LegendItem = styled.li`
    display: inline-block;
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    line-height: 3rem;
    color: ${theme.colors.black};

    &::before {
        display: inline-block;
        position: relative;
        top: 3px;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        content: "";
        background-color: ${theme.colors.black};
        border-radius: 50%;
    }

    & + li {
        margin-left: ${theme.space[3]}px;
    }

    html[dir="rtl"] & {
        & + li {
            margin-left: 0;
            margin-right: ${theme.space[3]}px;
        }
    }
`;

export const ExtraLegendItem = styled(LegendItem)`
    &::before {
        background-color: ${theme.colors.platinumDark};
    }
`;

export const ExceedLegendItem = styled(LegendItem)`
    color: ${theme.colors.error};
    &::before {
        background-color: ${theme.colors.error};
    }
`;

export const Form = styled.div`
    margin-top: ${theme.space[4]}px;

    ${FormStyles.Checkbox} {
        &:nth-child(1),
        &:nth-child(2) {
            margin-top: 0;
        }

        &:nth-last-child(1),
        &:nth-last-child(2) {
            margin-bottom: 0;
        }
    }

    @media ${getBreakpoint("up", "md")} {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: ${theme.space[3]}px;
    }
`;

export const StatisticBar = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 30px;
    margin: ${theme.space[4]}px 0 ${theme.space[3]}px;
    overflow: hidden;
`;

export const StatItem = styled.div<ColorProps & MaxWidthProps>`
    width: 100%;
    &:not(:first-child) {
        border-left: 1px solid ${theme.colors.white};
    }
    ${maxWidth};
    ${color};

    html[dir="rtl"] & {
        &:not(:first-child) {
            border-left: none;
            border-right: 1px solid ${theme.colors.white};
        }
    }
`;
